import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Button } from '@material-ui/core'
import OnEvent from 'react-onevent'

// actions

import { recoverPassword } from '../actions/auth'
// local files

import ModifiedTextInput from '../components/common/ModifiedTextInput'
import ContainerWithTitle from '../containers/HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'
import qs from 'query-string'
import validateInput from '../utils/validations/ResetPassword'

class ResetPassword extends PureComponent {
  state = {
    password: '',
    confirmPassword: '',
    loading: false,
    errors: {},
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onSubmit = () => {
    const searchParams = window.location.search
    const queryParams = qs.parse(searchParams)
    const { code } = queryParams

    const { password, confirmPassword } = this.state

    if (this.isValid(password, confirmPassword)) {
      this.setState({
        loading: true,
      })

      this.props
        .dispatch(
          recoverPassword({
            resetCode: code,
            password,
          }),
        )
        .then(() => {
          this.props.history.push('/login')
        })
        .catch((err) =>
          this.setState({
            loading: false,
            errors: {},
          }),
        )
    }
  }

  isValid = (password, confirmPassword) => {
    const { errors, isValid } = validateInput({
      password: password,
      confirmPassword: confirmPassword,
    })

    if (!isValid) {
      this.setState({ errors })
    }

    return isValid
  }

  render() {
    const { password, confirmPassword, errors } = this.state

    return (
      <OnEvent enter={this.onSubmit}>
        <Grid className="rightBlockLogin" item xs={11} sm={7} md={11} lg={7}>
          <div>
            <h1 className="big-header slim-heading">Reset Password</h1>
          </div>
          <ModifiedTextInput
            error={errors.password}
            type="password"
            id="password"
            placeholder="Password"
            margin="normal"
            className="margin-top-medium"
            onChange={this.onChange}
            value={password}
            name="password"
            helperText={errors.password}
          />

          <ModifiedTextInput
            error={errors.confirmPassword}
            type="password"
            id="confirmPassword"
            placeholder="Confirm Password"
            margin="normal"
            className="margin-top-medium"
            onChange={this.onChange}
            value={confirmPassword}
            name="confirmPassword"
            helperText={errors.confirmPassword}
          />
          <div className="vertical-middle margin-top-small">
            <Link className="align-auto-right black-link" to="/login">
              Back to login
            </Link>
          </div>
          <div className="margin-top-medium">
            <Button onClick={this.onSubmit} className="float-right" id="login-button">
              Submit
            </Button>
          </div>
        </Grid>
      </OnEvent>
    )
  }
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(SideCoverHOC(ContainerWithTitle(ResetPassword, 'BLAZE Reset Password')))



// WEBPACK FOOTER //
// ./src/containers/ResetPassword.js